<template>
  <div class="championships">
    <span id="c-add-up">
      <ChampionshipsAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('championships.cards.title')">
      <template slot="actions">
        <va-popover :message="`${$t('championships.tooltips.order')}`" placement="bottom">
          <va-button
            color="gray"
            icon="fa fa-list-ul"
            :to="{ name: 'championships-order'}"
          />
        </va-popover>
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#c-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="championships"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('championships.tooltips.seasons')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trophy"
              :to="{ name: 'seasons', params: { championship: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('championships.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#c-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('championships.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingUpload"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ChampionshipsAddUpdate from './ChampionshipsAddUpdate'

const perPage = 10
export default {
  name: 'championships',
  components: {
    ChampionshipsAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.championships.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.logo,
            path: 'championships',
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_championship_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      championships: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    championships: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        championships: championship(limit: $perPage, offset: $page, order_by: {id: asc}) {
          id
          name
          logo
          is_category
          category {
            id
            name
          }
          is_api
          id_api
          is_classification
          order
          slug
          show
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: championship_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('championships.headings.name'),
        width: '60%',
      }, {
        name: 'is_category',
        title: this.$t('championships.headings.is_category'),
        width: '20%',
        callback (value) {
          return value ? 'Sim' : 'Não'
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('championships')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.championships.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
